
import { DisenioPaginas } from '../../layout';
import { FormCreateUpdateBodega } from '../../components';




export const CrearBodegas = () => {


    const initialState = {
        nombre: '',
        granja: '',
        alto: '',
        ancho: '',
        largo: '',
    };
    

    
    return (

        <DisenioPaginas titulo="Crear Bodega" url={1} add={false} subtitulo="Información de bodega">
            <FormCreateUpdateBodega initialState={initialState} />
        </DisenioPaginas>

    )
}
